<template>
  <div class="pwa-test-page">
    <div class="container">
      <h1>PWA Test Page</h1>
      <p>Эта страница предназначена для тестирования PWA функциональности.</p>
    </div>
  </div>
</template>

<script>
export default {
    name: "PWATestPage",
};
</script>

<style lang="scss" scoped>
.pwa-test-page {
  min-height: 100vh;
  min-height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  //background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  padding-left: calc(20px + env(safe-area-inset-left));
  padding-right: calc(20px + env(safe-area-inset-right));
}

.container {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
}

h1 {
  color: #333;
  margin-bottom: 20px;
  font-size: 2.5rem;
}

p {
  color: #666;
  font-size: 1.2rem;
}

/* PWA specific styles */
@media (display-mode: standalone) {
  .pwa-test-page {
    padding-top: calc(40px + env(safe-area-inset-top));
    padding-bottom: calc(40px + env(safe-area-inset-bottom));
  }
  
  .container {
    margin-top: env(safe-area-inset-top);
    margin-bottom: env(safe-area-inset-bottom);
  }
}

@media (max-width: 768px) {
  .container {
    padding: 20px;
    margin: 10px;
  }
  
  h1 {
    font-size: 2rem;
  }
}

/* iPhone X and newer safe area support */
@supports (padding: max(0px)) {
  .pwa-test-page {
    padding-top: max(20px, env(safe-area-inset-top));
    padding-bottom: max(20px, env(safe-area-inset-bottom));
    padding-left: max(20px, env(safe-area-inset-left));
    padding-right: max(20px, env(safe-area-inset-right));
  }
}
</style>
